import { render, staticRenderFns } from "./ProductRate.vue?vue&type=template&id=d0f0043e&v-if=isShowProductRating&"
import script from "./ProductRate.vue?vue&type=script&lang=js&"
export * from "./ProductRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports